import TopBar from "../../pages/TopBar/TopBar";
import BookingBar from "../../pages/HomePage/BookingBar";
import Footer from "../../pages/Footer/Footer";
import FloatingActions from "../../components/FloatingActions/FloatingActions"; // Import the new component
import GoldCoastRating from "../../components/GoldCoastRating/GoldCoastRating";
import styles from "./DashboardLayout.module.css";

import { Outlet } from "react-router-dom";

function DashboardLayout() {
  return (
    <div className={styles.DashboardLayout}>
      <div className={styles.RightSection}>
        {/* <div className={styles.RightSection}></div> */}
        <TopBar />
        <BookingBar />

        <main className={`Main ${styles.pageMain}`}>
          <Outlet />
        </main>

        <Footer />

        {/* Floating Buttons (WhatsApp + ScrollTop) */}
        <FloatingActions />
        <GoldCoastRating />
      </div>
    </div>
  );
}

export default DashboardLayout;
